<template>
	<div>
		<CModal title="Corriger un colis" size="lg" :show.sync="showModal">
			<form ref="mainForm" action="/api/pos_credit_note_items" method="post" axiosMethod="post">
				<input type="hidden" name="creditNote" :value="creditNote['@id']" />

				<CRow>
					<CCol sm="12">
						<div class="form-group">
							<label>Produit</label>
							<GTreeView
								v-model="productForm"
								input-name="product"
								placeholder="Rechercher un produit"
								:multiple="false"
								:default-options="true"
								:load-options="loadProducts"
								:async="true" />
						</div>
					</CCol>
					<CCol sm="6">
						<CInput name="kgSupp" label="KG Supp (en euros)" value="0" />
					</CCol>

					<CCol sm="6">
						<CInput v-model="unitPriceForm" name="unitPrice" label="Prix unitaire" />
					</CCol>

					<CCol col="12">
						<hr />
					</CCol>

					<CCol sm="4">
						<CInput name="saleQty" label="Colis vendus" />
					</CCol>
					<CCol sm="4">
						<CInput name="depotQty" label="Colis déposés" />
					</CCol>

					<CCol sm="4">
						<CSelect label="Type" :options="creditNoteTypes" name="type" />
					</CCol>
				</CRow>
			</form>

			<template #footer>
				<CButton color="secondary" v-on:click="showModal = false">Annuler</CButton>
				<CButton color="success" v-on:click="onSubmit($refs.mainForm)">Ajouter</CButton>
			</template>
		</CModal>
	</div>
</template>

<script>
	import GTreeView from '@/components/ghostlexly-components/GTreeView';
	export default {
		name: 'credit-notes-items-add',
		components: { GTreeView },
		data() {
			return {
				productForm: null,
				unitPriceForm: 0,
				showModal: false,
				creditNote: {},
				creditNoteTypes: [
					{
						label: 'Avoir',
						value: 'pos_credit_note_item.type.due',
					},
					{
						label: 'Compl',
						value: 'pos_credit_note_item.type.add',
					},
				],
			};
		},

		watch: {
			productForm(newVal) {
				this.$axios.get(newVal).then(res => {
					this.unitPriceForm = res.data.price;
				});
			},
		},

		methods: {
			onSubmit: function (form) {
				this.$formDataToApi.sendForm(form).then(res => {
					if (res.status === 200 || res.status === 201) {
						this.showModal = false;
						this.$emit('refresh');
					}
				});
			},

			loadProducts({ action, searchQuery, callback }) {
				if (action === 'ASYNC_SEARCH') {
					let params = new URLSearchParams();
					params.append('search_autocomplete', searchQuery);

					return this.$axios.get(`/api/products?${params.toString()}`).then(res => {
						const options = res.data['hydra:member'].map(item => {
							let label = item.name;

							return {
								'@id': item['@id'],
								name: label,
							};
						});

						if (action === 'ASYNC_SEARCH') {
							callback(null, options);
						}
					});
				}
			},
		},
	};
</script>
